// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaG = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11.203 13.15v-1.456h5.208l.504.63c-.07 3.178-2.184 4.872-4.872 4.872-3.052 0-5.11-2.114-5.11-5.208 0-3.01 1.96-5.236 5.082-5.236 2.296 0 3.85 1.19 4.494 2.814l-1.792.336c-.448-1.008-1.414-1.652-2.688-1.652-2.086 0-3.29 1.554-3.29 3.71 0 2.198 1.218 3.738 3.304 3.738 1.848 0 2.87-1.078 3.066-2.548z" />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaG;
